import { useAtom } from 'jotai'
import lodash from 'lodash'
const { isEqual, isEqualWith } = lodash
import { viewStateStore } from '../store'
import { useViewStateOriginalPropAtom, useViewStatePropAtom } from './atoms'
import { useViewStateScope } from './view-state-scope'
import type {
  UseViewStatePropMetadata,
  UseViewStatePropResponse,
} from './types'
import type { Scope } from '../types'

export function useViewStateProp<T = undefined>(
  key: string,
): UseViewStatePropResponse<T | undefined>
export function useViewStateProp<T>(
  key: string,
  defaultValue: T,
  scope?: Scope,
): UseViewStatePropResponse<T>
export function useViewStateProp<T>(
  key: string,
  defaultValue: T | undefined,
  scope?: Scope,
): UseViewStatePropResponse<T | undefined>
export function useViewStateProp<T>(
  key: string,
  defaultValue?: T,
  scope?: Scope,
): UseViewStatePropResponse<T | undefined> {
  const actualScope = useViewStateScope(scope)
  const currentAtom = useViewStatePropAtom<T | undefined>(
    key,
    actualScope,
    defaultValue,
  )
  const originalAtom = useViewStateOriginalPropAtom<T | undefined>(
    key,
    actualScope,
    defaultValue,
  )

  const [current, setCurrent] = useAtom(currentAtom, { store: viewStateStore })
  const [original, setOriginal] = useAtom(originalAtom, {
    store: viewStateStore,
  })

  const meta: UseViewStatePropMetadata<T | undefined> = {
    hasChanged: !isEqualWith(current, original, (a, b) => {
      return isEqual(a, b) || JSON.stringify(a) === JSON.stringify(b)
    }),
    initialValue: original,
    setInitialValue: setOriginal,
  }

  return [current, setCurrent, meta]
}
